<template>
  <b-table
    id="ReturnProductAdjustmentStockTable"
    ref="ReturnProductAdjustmentStockTable"
    hover
    small
    sort-icon-left
    head-variant="light"
    :items="items"
    :fields="fields"
  >
    <template v-slot:cell(index)="row">
      <div class="d-flex align-items-center justify-content-center">
        {{ row.index + 1 }}.
      </div>
    </template>

    <template v-slot:cell(adjustmentAmount)="row">
      <InputNumberField
        :adjustStock="row.item.adjustmentAmount"
        :onChange="value => onChangeAdjustReturnStock(row, value)"
        :max="0"
        :min="-Number(row.item.productQtyOnGR || 0)"
      />
    </template>

    <template v-slot:cell(currentStockToAfterAdjustment)="row">
      <PreAndPostStockField
        :currentStock="convertUnitStock(row)"
        :adjustStock="row.item.adjustmentAmount"
        :onChange="value => onChangeAdjustReturnStock(row, value)"
        :max="Number(row.item.productAvailableStock || 0)"
        :min="
          Number(row.item.productAvailableStock || 0) -
          Number(row.item.productQtyOnGR || 0)
        "
      />
    </template>
  </b-table>
</template>

<script>
import BigNumber from "bignumber.js";
import PreAndPostStockField from "@/components/table/stock/fields/PreAndPostStockField.vue";
import InputNumberField from "@/components/table/stock/fields/InputNumberField.vue";

export default {
  name: "ReturnProductAdjustmentStockTable",
  components: { PreAndPostStockField, InputNumberField },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      fields: [
        {
          key: "index",
          label: "",
          class: "text-center",
          thStyle: { width: "4%" },
          tdStyle: { width: "4%" },
        },
        {
          key: "productNoAndName",
          label: "รหัสสินค้า - ชื่อสินค้า*",
          thStyle: { width: "34%" },
          tdStyle: { width: "34%" },
        },
        {
          key: "productQtyOnGR",
          label: "จำนวนจากใบรับสินค้า",
          thStyle: { width: "10%" },
          tdStyle: { width: "10%" },
        },
        {
          key: "adjustmentAmount",
          label: "จำนวนที่ปรับปรุง",
          thStyle: { width: "17%" },
          tdStyle: { width: "17%" },
        },
        {
          key: "currentStockToAfterAdjustment",
          label: "สต๊อก (ปัจจุบัน→หลังปรับปรุง)",
          thStyle: { width: "21%" },
          tdStyle: { width: "21%" },
        },
        {
          key: "productUnit",
          label: "หน่วยสินค้า",
          thStyle: { width: "14%" },
          tdStyle: { width: "14%" },
          tdClass: "text-wrap-cell",
        },
      ],
    };
  },
  methods: {
    convertUnitStock(row) {
      return row.item.productAvailableStock;
    },
    onChangeAdjustReturnStock(row, value) {
      const num = Number(value);
      this.$set(row.item, "adjustmentAmount", num);
      const current = Number(row.item.productAvailableStock) || 0;
      const afterAdjustment = new BigNumber(current).plus(num).toFixed(2);
      this.$set(row.item, "currentStockToAfterAdjustment", afterAdjustment);
    },
  },
};
</script>
